<template>
  <div class="renovation">
    <Card :dis-hover="true" :bordered="false">
      <iframe
        src="https://m.amap.com/around/?locations=120.222241,30.287459&keywords=美食,KTV,地铁站,公交站&defaultIndex=3&defaultView=&searchRadius=5000&key=51396da5b0b68b144d6c7a37ec21c5c6"
        frameborder="0"
        style="width: 100%;height: 1200px;"
      ></iframe>
    </Card>
  </div>
</template>

<script>
import { Card } from 'iview'
import { propsCall } from '@/common/propsCall'
import { request } from '@/common/request'
export default {
  ...propsCall({
    name: 'renovationMange-renovation',
    components: {
      Card,
    },
    data() {
      return {}
    },
    created() {},
    mounted() {},
    methods: {},
  }),
}
</script>

<style lang="less">
@import './index.less';
@import '../../my-theme/global.less';
</style>
